import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Loader, MessageBlock, Toggle, Tooltip } from '@getro/rombo';
import { Info } from 'lucide-react';
import strings from '../../../../strings';

const CrmContacts = ({ sortUnenrichedToBottom, isLoading, fetchError, onToggle }) => {
  if (fetchError) {
    return <MessageBlock>{strings.genericError}</MessageBlock>;
  }

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Flex alignItems="center" justifyContent="space-between" sx={{ gap: '16px' }}>
      <Flex sx={{ flexDirection: 'column', rowGap: '4px' }}>
        <Flex alignItems="center" sx={{ gap: '6px' }}>
          <Text lineHeight="140%" fontSize="14px" fontWeight="500" as="h4">
            Prioritize contacts with complete data
          </Text>
          <Tooltip
            position="top"
            content={
              <Box
                as="p"
                color="neutral.0"
                fontSize="13px"
                lineHeight="1.4"
                fontWeight="400"
                sx={{ maxWidth: '240px' }}
              >
                Enriched contacts have verified details like current title, company, and email. Unenriched contacts may
                only have a name.
              </Box>
            }
            trigger={
              <Box
                as="button"
                type="button"
                aria-label="More info about prioritizing contacts"
                sx={{
                  display: 'inline-flex',
                  cursor: 'pointer',
                  color: 'text.subtle',
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  margin: 0,
                  lineHeight: 1,
                }}
              >
                <Info size={14} aria-hidden="true" />
              </Box>
            }
          />
        </Flex>
        <Text as="p" color="text.main" lineHeight="20px" fontSize="14px">
          On the Contacts page, contacts with enriched profiles appear first. Contacts still missing key data are moved
          to the bottom.
        </Text>
      </Flex>
      <Toggle size="large" onChange={onToggle} checked={sortUnenrichedToBottom} />
    </Flex>
  );
};

CrmContacts.propTypes = {
  sortUnenrichedToBottom: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  fetchError: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default CrmContacts;
